<template>
  <main class="sidekick-search">
    <div
      class="nft-search px-5"
      :class="{ container: found == 'notyet', 'container-xxl': found == 'yes' }"
    >
      <div class="row px-sm-0">
        <div class="col-2 d-none d-md-block logo" v-else>
          <img
            src="@/assets/rebrand/nav/snkrhud-logo-white.png"
            alt="snkrhud white logo"
            class="img-logo -wht img-fluid snkrhud-logo"
          />
        </div>
        <div
          class="col  search"
          action=""
          :clas="{ 'col-sm-8': isFlowscore, 'col-sm-10': !isFlowscore }"
        >
          <label for="search">Search for stuff</label>
          <input
            id="search"
            type="search"
            placeholder="Enter NFT ID"
            autofocus
            required
            v-model="snkrhdnftName"
            @keyup.enter="searchSnkrhd(snkrhdnftName)"
          />
          <!-- <button type="submit">Go</button>   -->
        </div>
      </div>
    </div>
    <div
      class="nft-details container-xxl px-5"
      :style="{ marginTop: found == 'notyet' ? '0' : 'min(17vw, 110px)' }"
    >
      <div
        class="nft-details row px-3 px-sm-0 found flex-column flex-sm-row "
        v-if="found == 'yes'"
      >
        <div class="col nft-img">
          <h2 class=" nft-code top d-block d-sm-none">{{ nftData["Revealed Name"] }}</h2>
          <img v-if="main_nft" :key="main_nft" :src="main_nft" />
        </div>
        <div class="col d-flex flex-column justify-content-between nft-info">
          <div class="nft-info__top">
            <div class="nft-code bottom d-none d-sm-block">
              <h2 class="bottom d-none d-lg-block m-0" v-resize-text="{ ratio: 0.28, delay: 0 }">
                {{ nftData["Revealed Name"].slice(0, 3) }}
                <br />
                {{ nftData["Revealed Name"].slice(4, 8) }}
              </h2>
              <h2 class="bottom d-block d-lg-none m-0" v-resize-text="{ ratio: 0.3, delay: 0 }">
                {{ nftData["Revealed Name"].slice(0, 3) }}
                <br />
                {{ nftData["Revealed Name"].slice(4, 8) }}
              </h2>
            </div>
            <div class="nft-rank">
              <div class="rank__title">
                <p v-resize-text="{ minFontSize: 8, delay: 0 }">Rank</p>
              </div>
              <div class="rank__wrapper ">
                <h3 class="rank__number" v-resize-text="{ ratio: 0.4, delay: 0 }">#{{ rank }}</h3>
              </div>
            </div>
            <div class="nft-score">
              <div class="score__wrapper">
                <h3 class="score__text m-0" v-resize-text="{ ratio: 0.4, delay: 0 }">
                  {{ Math.round(nftData["calculated"]) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="nft-info__traits">
            <table>
              <thead>
                <tr>
                  <th>Part</th>
                  <th>Code</th>
                  <th>Percentage</th>
                  <th>Total Pieces</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(part, index) in nftData['parts']" v-bind:key="index">
                  <td>{{ index }}</td>
                  <td class="text-truncate">{{ nftData["parts"][index].code }}</td>
                  <td style="text-align: center;">
                    {{ parseFloat(nftData["parts"][index].percent) }}%
                  </td>
                  <td style="text-align: center;">
                    <span class="d-none d-lg-block"
                      >({{ nftData["parts"][index].pcs }} / {{ noOfNft }})</span
                    >
                    <span class="d-block d-lg-none">({{ nftData["parts"][index].pcs }})</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row px-5 px-sm-0 notfound" v-else-if="found == 'notyet'"></div>
      <div class="row px-5 px-sm-0 notfound text-center" v-else-if="found == 'no'">
        <h2>Not Found</h2>
      </div>
    </div>
    <div class="toplist container">
      <div class="row px-5 px-sm-0">
        <div class="col">
          <h1 class="title" id="rankTitle">Ranking</h1>
          <div class="nft-list__dots d-sm-none">
            <div
              class="dots to-left"
              v-scroll-to="{ el: '#nftRank', container: '#nftList', x: true }"
              :class="{ filled: isNftListColsVisible.rank }"
            />
            <div
              class="dots to-right"
              v-scroll-to="{ el: '#nftScore', container: '#nftList', x: true }"
              :class="{ filled: isNftListColsVisible.score }"
            />
          </div>
          <div class="nft-list" id="nftList" @scroll="onScroll">
            <table>
              <thead>
                <tr>
                  <th class="" id="nftRank" ref="nftRank">Rank</th>
                  <th class="">NFT</th>
                  <th class="">Name</th>
                  <th class="" id="nftScore" ref="nftScore">Score</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rank, index) in rankList" v-bind:key="index">
                  <td>
                    <a class="revName" @click="searchSnkrhd(rankList[index]['Revealed Name'])">{{
                      index + 1
                    }}</a>
                  </td>
                  <td>
                    <a class="revName" @click="searchSnkrhd(rankList[index]['Revealed Name'])"
                      ><img
                        :src="
                          'https://ik.imagekit.io/jtuio7958s/ongaia/tr:w-200,h-200/' +
                            rankList[index]['Revealed Image']
                        "
                        class="nftRankImg lazy"
                    /></a>
                  </td>
                  <td>
                    <a class="revName" @click="searchSnkrhd(rankList[index]['Revealed Name'])">{{
                      rankList[index]["Revealed Name"]
                    }}</a>
                  </td>
                  <td>
                    <a class="revName" @click="searchSnkrhd(rankList[index]['Revealed Name'])">{{
                      Math.round(rankList[index]["calculated"])
                    }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="loadmore container">
      <div class="row px-5 px-sm-0">
        <div class="col d-flex justify-content-center">
          <button @click="loadRanking(true)">Load More</button>
        </div>
      </div>
    </div>
    <div class="about-bg" />
  </main>
</template>
<script>
import ResizeText from "vue-resize-text";
import json from "../db/db.json";

export default {
  name: "SidekickSearch",
  directives: {
    ResizeText
  },
  data() {
    return {
      isFlowscore: false,
      snkrhd: "",
      snkrhdnftName: "",
      nftData: [],
      parts: [],
      found: "notyet",
      rank: "",
      top: 100,
      rankList: [],
      main_nft: null,
      noOfNft: json.snkrhd.length,
      isNftListColsVisible: {
        rank: true,
        score: false
      }
    };
  },
  created() {
    try {
      // const res = await axios.get(baseURL);
      // this.snkrhd = res.data;
      this.loadRanking(false);
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    searchSnkrhd(id) {
      window.scrollTo(0, 0);

      this.snkrhdnftName = id;
      this.nftData = [];
      // this.parts = [];
      this.rank = "";
      this.main_nft = null;
      this.found = "notyet";
      try {
        const data = json.snkrhd;

        for (let i = 0; i < data.length; i++) {
          if (
            data[i]["Revealed Name"] == id ||
            data[i]["Revealed Name"] == `SK1-${id}` ||
            data[i]["Revealed Name"] == `SK1-0${id}` ||
            data[i]["Revealed Name"] == `SK1-00${id}` ||
            data[i]["Revealed Name"] == `SK1-000${id}`
          ) {
            this.found = "yes";
            this.rank = i + 1;
            this.nftData = data[i];
            this.main_nft = `https://ik.imagekit.io/jtuio7958s/ongaia/tr:w-1000,h-1000/${this.nftData["Revealed Image"]}`;
            this.nftData["Total Score"] = Math.round(this.nftData["Total Score"]);
            // this.parts = this.getRarity(this.nftData);
            // console.log(this.parts)
          }
        }
      } catch (e) {
        console.error(e);
      }

      if (this.found == "notyet" && id != "") {
        this.found = "no";
      }
    },
    loadRanking(loadMore) {
      const data = json.snkrhd;
      if (loadMore) {
        this.top += 100;
      }
      this.rankList = data.slice(0, this.top);
    },
    checkNftListColVisible() {
      const nftRank = this.$refs.nftRank.getBoundingClientRect();
      const nftScore = this.$refs.nftScore.getBoundingClientRect();

      if (
        nftRank.top >= 0 &&
        nftRank.left >= 0 &&
        nftRank.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        nftRank.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        this.isNftListColsVisible.rank = true;
        this.isNftListColsVisible.score = false;
      }
      if (
        nftScore.top >= 0 &&
        nftScore.left >= 0 &&
        nftScore.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        nftScore.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        this.isNftListColsVisible.score = true;
        this.isNftListColsVisible.rank = false;
      }
    },
    onScroll() {
      this.checkNftListColVisible();
    }
  }
  /* mounted() {
    console.log(this.$refs.nftRank);
  } */
};
</script>
<style lang="scss">
@import "../assets/styles/fontstyle.css";
@import "../assets/styles/sidekicksearch.scss";

//utility class
.container-xxl {
  max-width: 1420px !important;
  margin: 0 auto;
}

.revName {
  cursor: pointer;
}

:root {
  --rad: 0.7rem;
  --dur: 0.3s;
  --color-dark: #2f2f2f;
  --color-light: #fff;
  --color-brand: #57bd84;
  --font-fam: "Lato", sans-serif;
  --height: 5rem;
  --btn-width: 6rem;
  --bez: cubic-bezier(0, 0, 0.43, 1.49);
}

body {
  background: var(--color-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
html {
  box-sizing: border-box;
  height: 100%;
  font-size: 10px;
}
*,
*::before,
*::after {
  box-sizing: inherit;
}

form {
  position: relative;
  width: 30rem;
  background: var(--color-brand);
  border-radius: var(--rad);
}
input {
  height: var(--height);
  font-family: var(--font-fam);
  border: 0;
  color: var(--color-dark);
  font-size: 1.8rem;
}
input[type="search"] {
  outline: 0;
  width: 100%;
  background: var(--color-light);
  padding: 0 1.6rem;
  border-radius: var(--rad);
  appearance: none;
  transition: all var(--dur) var(--bez);
  transition-property: width, border-radius;
  z-index: 1;
  position: relative;
}
input:not(:placeholder-shown) {
  /* border-radius: var(--rad) 0 0 var(--rad); */
  /* width: calc(100% - var(--btn-width)); */
  /* button {
    display: block;
  } */
}
label {
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}

.snkr-navigation {
  border-bottom: unset !important;
  .nav-logo::before {
    display: none !important;
  }
}

.container::after,
.container::before,
.row::before,
.row::after {
  display: none !important;
  content: unset;
}

.sidekick-search {
  margin-top: max(6vw, 60px);
}
.nft-search {
  //max-width: 1420px !important;
  margin-top: 6vw;
  .logo {
    img {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(5%, -50%);
    }
    .snkrhud-logo {
      width: 80%;
      /* left: 50%;
      transform: translate(0-50%, -50%); */
    }
    .flowScoreLogo {
      width: 90%;
    }
  }
  .search {
    ::placeholder {
      text-align: center;
      font-family: Archia regular, sans-serif !important;
      text-transform: uppercase;
    }
  }
}
.nft-details {
  color: #fff;
  max-width: 1420px !important;

  .nft-img {
    flex: 5;
    img {
      max-width: 100%;
      min-height: 250px;
      object-fit: cover;
    }
    .nft-code {
      font-size: 10vw;
      margin-bottom: 1.5rem;
      font-family: Kawaru, sans-serif;
    }
  }
  .nft-info {
    flex: 6;

    .nft-info__top {
      display: flex;
      gap: min(5vw, 5em);
      font-family: Kawaru, sans-serif;

      //height: 50%;

      & > * {
        &:not(:last-child) {
          position: relative;
          &::after {
            //divider
            width: min(5vw, 5em);
            height: 110%;
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(100%, -50%);
          }
        }
        &:nth-child(1) {
          &::after {
            background: url("../assets/rebrand/sidekicksearch/divider-white.svg") center no-repeat;
          }
        }
        &:nth-child(2) {
          &::after {
            background: url("../assets/rebrand/sidekicksearch/divider-lime.svg") center no-repeat;
          }
        }
      }

      .nft-code {
        //flex: 5;
        width: 30%;
        h2 {
          line-height: 0.9em;
          // transform: translateY(1%);
        }
      }
      .nft-rank {
        flex: 5;
        display: grid;
        place-items: center;
        position: relative;

        color: #31fd9c;

        .rank__title {
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          text-align: right;

          //font-size: 1.2vw;

          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            background: #31fd9c;
            height: 30%;
            width: 52%;
            transform: translate(20%, -50%);
          }

          p {
            margin: 0;
          }
        }

        .rank__wrapper {
          width: 100%;
          margin-top: 20%;
          text-align: center;
        }
      }
      .nft-score {
        flex: 4;
        display: grid;
        place-items: center;
        background: url("../assets/rebrand/sidekicksearch/score-ring.png") center / contain
          no-repeat;

        color: #31fd9c;

        .score__wrapper {
          width: 100%;
          text-align: center;
        }
      }
    }

    .nft-info__traits {
      font-family: Archia regular, sans-serif !important;

      margin-top: auto;

      table {
        width: 100%;

        tr {
          th,
          td {
            border: 1px solid #706d6d;
            padding: 0.5em;
            font-size: min(1vw, 14px);
          }
          th {
            font-family: Kawaru, sans-serif;
            text-align: center;
          }
        }
      }
    }
  }
  .notfound {
    justify-content: center;
    font-family: Archia regular, sans-serif !important;
  }
}

.toplist {
  font-size: 1.8rem;
  //display: flex;
  text-align: center;
  justify-content: center;
  margin: auto;
  margin-top: max(5vw, 70px);

  .title {
    color: #fff;
    font-family: Kawaru, sans-serif;
    font-size: max(3vw, 3rem);
    margin-bottom: 40px;
  }
  .nft-list__dots {
    display: flex;
    justify-content: center;
    gap: 1rem;
    .dots {
      aspect-ratio: 1/1;
      width: 1.6rem;
      border: #31fd9c solid 1px;
      border-radius: 100px;
      margin-bottom: 15px;
    }
    .filled {
      background: #31fd9c;
    }
  }
  .nft-list {
    overflow-y: scroll;

    table {
      width: max(100%, 500px);
      border-collapse: collapse;
      font-family: Archia regular, sans-serif !important;

      tr {
        th,
        td {
          &:nth-child(1) {
            width: 10%;
          }
          border: 1px solid #706d6d;
          width: 30%;
        }

        th {
          font-family: Kawaru, sans-serif;
          color: #fff;
          font-size: 2.5rem;
          padding: 0.3em;
        }

        td {
          &:nth-child(1),
          &:nth-child(4) {
            font-family: Kawaru, sans-serif;
            font-size: clamp(2rem, 2vw, 4rem);
            a {
              color: #31fd9c;
            }
          }
          &:nth-child(4) {
            background: url("../assets/rebrand/sidekicksearch/score-ring.png") center /
              max(7vw, 60px) no-repeat;
          }
          a {
            color: #fff;
          }
          .nftRankImg {
            width: max(8vw, 70px);
            object-fit: contain;
          }
        }
      }
    }
  }
}

.loadmore button,
.loadmore button:hover {
  margin: 5vw auto;
  font-family: Archia regular, sans-serif !important;
  //background: #000;
  background: #ff661f !important;
  padding: 1rem 2rem;
  border: none !important;
  color: #fff;
  width: 50%;
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
}

@media only screen and (max-width: 992px) {
  .nft-details {
    .nft-info {
      .nft-info__top {
        .nft-code {
          width: 25%;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .sidekick-search {
    margin-bottom: 5rem;
    margin-top: 20vw;
  }
}

@media only screen and (max-width: 576px) {
  .sidekick-search {
    margin-top: 24vw;
  }
  .nft-details {
    .nft-info {
      .nft-info__top {
        height: 40vw;
        margin-top: 10%;
        gap: 12vw;
        & > * {
          &:not(:last-child) {
            position: relative;
            &::after {
              //divider
              height: 90%;
              width: 12vw;
            }
          }
        }
        .nft-rank {
          flex: 1;
          .rank__wrapper {
            margin: 0;
          }
        }
        .nft-score {
          flex: 1;
          /* background: url("../assets/rebrand/sidekicksearch/score-ring.png") center / contain
            no-repeat; */
        }
      }
      .nft-info__traits {
        overflow-y: scroll;
        margin-top: 5%;
        table {
          tr {
            th,
            td {
              font-size: 14px;
            }
            th {
              padding: 0.3em 1em;
              font-size: 2rem;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .toplist {
    .title {
      text-align: left;
      margin-bottom: 20px;
    }
    .nft-list {
      table {
        tr {
          th,
          td {
            &:nth-child(2) {
              width: 100px;
            }
          }
          th {
            padding: 0.3em 1em;
            font-size: 2rem;
          }
          td {
            height: 100px;
            &:nth-child(2) {
              img {
                width: 100px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
